import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FilterBarComponent } from "@app/directives/_resourceFilters/filter-bar/filter-bar.component";
import { FilterTriggerType, IFilterBarFilter } from "@app/directives/_resourceFilters/filter-bar/filter-bar.models";
import { VButtonDropdownComponent } from "@directives/_core/v-dropdown/v-button-dropdown/v-button-dropdown.component";
import { IVehicle } from "@interfaces/IVehicle";
import { VehicleService } from "@services/vehicle.service";
import { VeriDate } from "@services/veriDate.service";
import "./vehicle-button-filter.component.scss";

@Component({
    selector: "vehicle-button-filter",
    template: require("./vehicle-button-filter.component.html")
})
export class VehicleButtonFilterComponent implements IFilterBarFilter<IVehicle> {
    @Input() selected: IVehicle;
    @Input() label = "All Vehicles";
    @Input() showAllItems = false;
    @Output() change = new EventEmitter<IVehicle>();

    @ViewChild(VButtonDropdownComponent) dropdown: VButtonDropdownComponent;

    // ---

    name = "Vehicle";
    icon = "fa-solid fa-truck fa-duotone";
    type: FilterTriggerType = "vehicle";

    vehicles: IVehicle[];

    itemPromise: angular.IPromise<any>;

    constructor(
        private readonly parent: FilterBarComponent,
        readonly elementRef: ElementRef<HTMLElement>,
        readonly vehicleService: VehicleService,
        private readonly veriDate: VeriDate
    ) {

    }

    onFilterOpen(): void {
        this.itemPromise = this.vehicleService.getVehicles({ includeLatestPlots: true, includePeripheralMappings: true }).then(vehicles => {
            this.vehicles = vehicles;

            // Now perform standard vehicle sort (todo: move to vehicle service)
            // General algorithm:
            // 1. Vehicles sorted by plot existence
            // 2. Vehicles sorted by plot age older than a week
            // 3. Vehicles sorted alphabetically
            var weekAgo = this.veriDate.createMoment(new Date()).add(-7, "d");
            this.vehicles.sort((v1, v2) => {
                // Parameterise this in service later
                var includePlots = true;

                if (includePlots) {
                    if (v1.Plot && !v2.Plot) {
                        return -1;
                    }

                    if (v2.Plot && !v1.Plot) {
                        return 1;
                    }

                    if (!v1.Plot && !v2.Plot) {
                        return 0;
                    }
                }

                // Time period taken from vehicle-status - move to service?
                if (v1.Plot.UtcMoment.isAfter(weekAgo) && v2.Plot.UtcMoment.isBefore(weekAgo)) {
                    return -1;
                }

                if (v1.Plot.UtcMoment.isBefore(weekAgo) && v2.Plot.UtcMoment.isAfter(weekAgo)) {
                    return 1;
                }

                return v1.ShortReg.localeCompare(v2.ShortReg);
            });
        });
    }

    filterPredicate(item: any, value?: IVehicle): boolean {
        // Try to find vehicle id
        if (item.VehicleId) {
            return item.VehicleId == value.Id;
        }

        if (item.vehicle) {
            return item.vehicle.Id == value.Id;
        }

        if (item.ShortReg) {
            return item.Id == value.Id;
        }

        // Dont know how to cope with this
        return false;
    }

    searchPredicate = (item: IVehicle, value?: any): boolean => {
        return this.vehicleService.vehicleSearchPredicate(item, value);
    }

    onVehicleClick(vehicle: IVehicle): void {
        this.selected = vehicle;

        this.change.emit(vehicle);
        this.parent.onFilterChange("vehicle", vehicle);

        if (this.selected) {
            this.label = vehicle.ShortReg;
        }
        else {
            this.label = "All Vehicles";
        }
    }

    clearSelectedVehicle(): void {
        this.onVehicleClick(null);
    }
}
